function localDay(value: number, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(value)
  const field = (type: string) => parts.find(part => part.type === type)?.value
  return `${field('year')}-${field('month')}-${field('day')}`
}

export function nextFocusDay(dueDate: string | null | undefined, timeZone: string, now = Date.now()): string | null {
  const dateOnly = dueDate && /^\d{4}-\d{2}-\d{2}$/.test(dueDate)
  const timestamp = dueDate ? Date.parse(dueDate) : now
  if (!dateOnly && !Number.isFinite(timestamp)) return null
  const base = dateOnly ? dueDate : localDay(timestamp, timeZone)
  if (!base || !/^\d{4}-\d{2}-\d{2}$/.test(base)) return null
  const value = new Date(`${base}T12:00:00.000Z`)
  if (Number.isNaN(value.getTime())) return null
  value.setUTCDate(value.getUTCDate() + 1)
  return value.toISOString().slice(0, 10)
}
